export default __webpack_public_path__ + "static/media/logo.955af2b2.png";